import { Outlet } from 'react-router-dom';
import { useFirmContext } from './providers/FirmProvider';
import { useFirm } from './queries/use-firm';

function FirmContainer(): JSX.Element {
    const { id } = useFirmContext();
    const firmQuery = useFirm(id);

    if (firmQuery.isLoading) {
        return <></>;
    }

    if (firmQuery.isError || !firmQuery.isSuccess) {
        return <p>Error!</p>;
    }

    return <Outlet />;
}
export default FirmContainer;
